import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useFeedbackAPIClient = () => {
  const { set, get } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getBugReports = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/feedback?feedbackType=bug-report`),
    );
  }, [activeUser, get]);

  const getFeatureRequests = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/feedback?feedbackType=feature-request`),
    );
  }, [activeUser, get]);

  const getGeneralFeedback = useCallback(async () => {
    return await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/feedback?feedbackType=general-feedback`),
    );
  }, [activeUser, get]);

  const submitBugReport = useCallback(
    async (fields) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/feedback`, {
          feedbackType: "bug-report",
          ...fields,
        }),
      );
    },
    [activeUser, set],
  );

  const submitFeatureRequest = useCallback(
    async (fields) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/feedback`, {
          feedbackType: "feature-request",
          ...fields,
        }),
      );
    },
    [activeUser, set],
  );

  const submitGeneralFeedback = useCallback(
    async (fields) => {
      return await withNetworkErrorHandling(() =>
        set(`users/${activeUser.userId}/feedback`, {
          feedbackType: "general-feedback",
          ...fields,
        }),
      );
    },
    [activeUser, set],
  );

  return {
    getBugReports,
    getFeatureRequests,
    getGeneralFeedback,
    submitBugReport,
    submitFeatureRequest,
    submitGeneralFeedback,
  };
};

export default useFeedbackAPIClient;
